import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader } from "../math/priceSources";
import { barsSinceHighestAt, barsSinceLowestAt } from "../math/windowExtremes";

const PERCENT = 100;

/**
 * Aroon (research §1.4), as TV Aroon: Up = 100 × (Period − bars since the
 * highest high of the last Period + 1 bars) / Period, Down the same for the
 * lowest low.
 */
export default {
  id: "aroon",
  name: "Aroon",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("period", "Period", 25, { max: 100 }),
  ],
  plots: [
    linePlot("up", "Up", PALETTE.BLUE),
    linePlot("down", "Down", PALETTE.RED),
  ],
  levels: [],

  calculate: (bars, { period }, series, fromIndex) => {
    const readHigh = priceReader(bars, PRICE_SOURCE.HIGH);
    const readLow = priceReader(bars, PRICE_SOURCE.LOW);

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.up[index] = (PERCENT * (period - barsSinceHighestAt(readHigh, index, period + 1))) / period;
      series.down[index] = (PERCENT * (period - barsSinceLowestAt(readLow, index, period + 1))) / period;
    }
  },
};
